<template>

    <div class="controls">
        <yes_no
            key="protocol_currency"
            @update:modelValue="changeCurrencyType"
            v-model="protocol.rate_from_protocol"
            base_class="mt-3"
            title="Курс валют"
            :radio_options="currencies_types">
        </yes_no>
    </div>
    
    <div class="currencies mt-2" v-if="has_currencies">
        <div v-if="parseFloat(protocol.usd_exchange_rate) > 0">
              <span class="bold">USD:</span>  {{protocol?.usd_exchange_rate}}
        </div>
        
        <div v-if="parseFloat(protocol.eur_exchange_rate) > 0">
            <span class="bold"> EUR:</span> {{protocol?.eur_exchange_rate}}
        </div>
    </div>
    
</template>

<script>
import Yes_no from "../../../../base/yes_no.vue";

export default {
    name: "protocol_currency",
    components: {Yes_no},
    props : {
        protocol : {
            type : Object
        }
    },
    
    emits : [
        'change_currency_type'
    ],
    
    data () {
        return {
        
        }
    },
    
    methods : {
        changeCurrencyType(new_val) {
            this.protocol.rate_from_protocol = new_val;
            this.$emit('change_currency_type',new_val);
        }
    },
    
    computed : {
        
        has_currencies() {
            return parseInt(this.protocol.rate_from_protocol) > 0;
        },
        
        currencies_types() {
            
            let base = [
                {value: 0, text: 'з заявок'},
                {value: 1, text: 'нацбанк'},
            ];
            
            if(parseInt(this.protocol.id > 0)) {
                base.push({
                    value: 2, text: 'нацбанк актуальний'
                });
            }
            
            return base;
        },
    },
}
</script>



<style scoped>

</style>